// ── red. tokens — Source of truth: design_handoff_red_webapp/source/red-tokens.jsx
// (Webapp + Mobile vereinheitlicht — editoriales Design auf beiden Plattformen.)
// Legacy-Keys bleiben für Backwards-Compat während der Migration.

export const T = {
  // NACHTMODUS — Deep Slate: etwas tiefer als vorher für mehr Premium-Tiefe.
  // Koralle #E4544A poppt stark auf dem dunklen Schiefer. Text warm-taupe.
  bg:          '#14151B',  // etwas tiefer als #15161A → mehr Tiefe
  surface:     '#1D1F26',  // leicht blaustichig-graues Panel
  surfaceHigh: '#252830',  // elevated Panels (Modals, Dropdowns)
  surfaceHi:   '#252830',
  surface2:    '#0F1014',  // tiefstes Grau (Sidebar-BG, eingelassene Wells)
  itemHover:   'rgba(255,255,255,0.060)',
  border:      '#2C2F3C',  // klar sichtbare Linien
  line:        '#2C2F3C',
  lineSoft:    '#23262E',

  // Brand red — v3 names "signal" preferred
  red:        '#E4544A',
  signal:     '#E4544A',
  redHover:   '#C73E3D',
  signalDark: '#C73E3D',
  redHi:      '#FF6A5C',
  signalHi:   '#FF6A5C',
  redDim:    '#2C1010',
  redBorder: '#3D1515',

  // Status — Editorial Pastell projektweit (Webapp + Mobile vereinheitlicht).
  // green = gain = #56B98A (vorher #2ECC71). Wer das alte knallige Buy-Grün
  // braucht, nutzt T.greenStrong.
  green:       '#56B98A',
  greenStrong: '#2ECC71', // Legacy fallback für sehr seltene Highlight-Stellen
  greenDim:    '#0D2B1A',
  greenBorder: '#1A4D2E',
  gain:        '#56B98A',
  loss:        '#E07A72', // Performance: Verlust = sanftes Rot (dark)
  gold:        '#F5C542',
  goldSoft:    '#F5A623',
  goldDim:     '#1A1400',
  goldBorder:  '#3A2C00',
  silver:      '#D4D5DE',
  silverDim:   '#1F2024',
  silverBorder:'#3A3D44',

  // Text — warmes Taupe (User-Wahl: NICHT kühles Neutralgrau, aber auch NICHT das
  // alte Dunkelbraun). text/sub bleiben das helle warme Taupe; nur `mute` wird vom
  // dunkelbraunen #6E6555 auf ein helleres Taupe gehoben, damit Sekundär-Labels
  // (Suchleiste, „Anzeige", Impressum) auf dem Anthrazit lesbar sind.
  text:  '#EAE6E0',  // warmes Off-White (User-Wahl: leicht taupe, nicht kalt)
  sub:   '#8C8A98',  // neutral-lila-grau (moderner als reines Taupe)
  muted: '#8C8A98',
  mute:  '#5A5868',  // tiefer Tertiär
  dim:   '#5A5868',
  white: '#FFFFFF',

  // Glassmorphism (kept for legacy)
  glass:          'rgba(255,255,255,0.03)',
  glassMid:       'rgba(255,255,255,0.055)',
  glassHigh:      'rgba(255,255,255,0.08)',
  glassBorder:    'rgba(255,255,255,0.08)',
  glassBorderRed: 'rgba(228,84,74,0.30)',
  glassBlur:      'blur(20px) saturate(180%)',
  glassBlurHeavy: 'blur(32px) saturate(200%)',

  // Gradients (v2) — redGradient beruhigt: tiefes Mattrot statt Neon (Calming-Pass).
  redGradient:    'linear-gradient(180deg, #C2453F 0%, #B33E3A 100%)',
  redGradientSub: 'linear-gradient(135deg, rgba(228,84,74,0.18) 0%, rgba(228,84,74,0.08) 100%)',
  silverGradient: 'linear-gradient(155deg, #EDEEF5 0%, #D4D5DE 50%, #8E8F98 100%)',

  // Shadows & glows — v3 Editorial: KEINE farbigen Glows mehr (siehe Memory
  // feedback_no_pills_borders_glow.md). Neutral-leichter Lift bleibt.
  redGlow:        'none',
  redGlowSoft:    '0 2px 8px rgba(0,0,0,0.20)',
  redGlowCTA:     '0 2px 6px rgba(0,0,0,0.22)',
  cardShadow:     '0 2px 8px rgba(0,0,0,0.36), 0 12px 32px rgba(0,0,0,0.28)',
  cardShadowLg:   '0 4px 16px rgba(0,0,0,0.42), 0 24px 56px rgba(0,0,0,0.36)',
  cardInset:      'inset 0 1px 0 rgba(255,255,255,0.05)',
  heroInset:      'inset 0 0 0 1px rgba(255,255,255,0.03)',

  // Search-„Well" — eine in die Header-Leiste eingelassene Mulde (dunkler als
  // die Leiste + Sunken-Inset oben dunkel / unten Highlight) statt schwebender
  // Pille. Theme-bewusst (Dark/Light getrennt).
  searchWellBg:      'rgba(0,0,0,0.30)',
  searchWellBgHover: 'rgba(0,0,0,0.20)',
  searchWellShadow:  'inset 0 1.5px 3px rgba(0,0,0,0.55), inset 0 -1px 0 rgba(255,255,255,0.05)',
  searchWellBorder:  'rgba(0,0,0,0.45)',

  // Navigation
  navBg:     'rgba(16,17,22,0.86)',
  navBlur:   'blur(30px) saturate(180%)',
  navBorder: 'rgba(255,255,255,0.07)',

  isDark: true,
};

export const T_LIGHT = {
  // TAGMODUS — Paper Grey: klare Elevation-Hierarchie (Karten HELLER als bg).
  // bg = mittelhelles Neutral-Grau (der „Raum"). surface = Off-White Pearl (Karten
  // schweben sichtbar). surfaceHi = fast weiß (Modals). surface2 = dunkler als bg
  // (eingelassene Flächen). nav glass = leicht dunkler als bg → eigene Ebene.
  bg:          '#E9E9E7',  // neutral mittelgrau — der Raum
  surface:     '#F4F4F2',  // pearl off-white — Karten (klar heller als bg)
  surfaceHigh: '#F9F9F8',  // near-white — genuine Elevation (Modals, Sheets)
  surfaceHi:   '#F9F9F8',
  surface2:    '#DFDEDD',  // etwas dunkler als bg — recessed Panels, Sidebar
  itemHover:   'rgba(0,0,0,0.04)',
  border:      '#CFCFCC',  // klare Hairlines
  line:        '#CFCFCC',
  lineSoft:    '#DADADB',

  red:        '#E4544A',
  signal:     '#E4544A',
  redHover:   '#C73E3D',
  signalDark: '#C73E3D',
  redHi:      '#FF6A5C',
  signalHi:   '#FF6A5C',
  redDim:    'rgba(228,84,74,0.10)',
  redBorder: '#F5C0BE',

  green:       '#4F9C73',
  greenStrong: '#27AE60',
  greenDim:    'rgba(79,156,115,0.10)',
  greenBorder: '#A3DDB8',
  gain:        '#4F9C73',
  // Calm-Doktrin: Verlust = neutrales warmes Grau (NICHT rot). Rot gehört allein
  // der Marke (Punkt + die eine Aktion). So kollidiert Marken-Rot nie mit „Minus".
  loss:        '#C2564E', // Performance: Verlust = sanftes Rot (User-Wahl Standard up/down)
  gold:        '#D6A82E',
  goldSoft:    '#F5A623',
  goldDim:     '#FDF8E7',
  goldBorder:  '#E8D48B',
  silver:      '#8E8F98',
  silverDim:   '#EEEEF1',
  silverBorder:'#D4D5DE',

  text:  '#1A1918',  // warm-schwarz (nicht kalt)
  sub:   '#625E58',  // warmes Sekundär-Grau
  muted: '#625E58',
  mute:  '#96918C',  // tertiär, lesbar auf pearl surface
  dim:   '#96918C',
  white: '#FFFFFF',

  glass:          'rgba(0,0,0,0.03)',
  glassMid:       'rgba(0,0,0,0.05)',
  glassHigh:      'rgba(0,0,0,0.08)',
  glassBorder:    'rgba(0,0,0,0.08)',
  glassBorderRed: 'rgba(228,84,74,0.28)',
  glassBlur:      'blur(20px) saturate(180%)',
  glassBlurHeavy: 'blur(32px) saturate(200%)',

  redGradient:    'linear-gradient(180deg, #C2453F 0%, #B33E3A 100%)',
  redGradientSub: 'linear-gradient(135deg, rgba(228,84,74,0.14) 0%, rgba(228,84,74,0.06) 100%)',
  silverGradient: 'linear-gradient(155deg, #EDEEF5 0%, #D4D5DE 50%, #8E8F98 100%)',

  redGlow:        'none',
  redGlowSoft:    '0 1px 4px rgba(0,0,0,0.08)',
  redGlowCTA:     '0 1px 3px rgba(0,0,0,0.10)',
  // Schatten neutral-schwarz (nicht warm-braun) — klarer, moderner
  cardShadow:     '0 1px 2px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.07), 0 16px 32px rgba(0,0,0,0.05)',
  cardShadowLg:   '0 1px 3px rgba(0,0,0,0.06), 0 8px 24px rgba(0,0,0,0.09), 0 32px 64px rgba(0,0,0,0.07)',
  cardInset:      'inset 0 1px 0 rgba(255,255,255,0.80)',  // top-edge Glanz auf pearl
  heroInset:      'inset 0 0 0 1px rgba(0,0,0,0.04)',

  // Search-„Well" — leichte Mulde in der hellen Header-Leiste (minimal dunkler
  // + Sunken-Inset oben dunkel / unten heller Rand). Siehe Dark-Theme oben.
  searchWellBg:      'rgba(0,0,0,0.045)',
  searchWellBgHover: 'rgba(0,0,0,0.025)',
  searchWellShadow:  'inset 0 1.5px 2px rgba(0,0,0,0.10), inset 0 -1px 0 rgba(255,255,255,0.7)',
  searchWellBorder:  'rgba(0,0,0,0.08)',

  navBg:     'rgba(220,220,218,0.94)',  // leicht dunkler als bg → eigene Glass-Ebene
  navBlur:   'blur(30px) saturate(160%)',
  navBorder: 'rgba(0,0,0,0.07)',

  isDark: false,
};

// Radien-Skala: Editorial setzt projektweit auf 3px ("sharp").
// Legacy-Keys werden auf 3 gemappt, damit alle alten Components automatisch
// scharf werden (Editorial v4 — Webapp+Mobile Vereinheitlichung).
// Echte Pill-Spezialfälle nutzen R.pill = 999 explizit.
export const R = {
  // v5 — Webapp organisch gerundet (wie Navbar/Mobile). soft = neuer Desktop-
  // Default; sharp bleibt für explizit flache Stellen (Tabellen/Trenner).
  sharp: 3,
  soft:  12,       // NEU: organischer Desktop-Default (Karten/Tiles/Controls)
  input: 12,       // iOS-Stil Eingabefelder (Adresse/Zahl)
  promo: 14,       // PromoCard im Sidebar-Footer
  pill: 999,       // Avatar-rechte-Seite, Topbar-Suchpill, Schließen-X
  // Legacy → auf den weichen Default gemappt (Webapp soll rund wirken)
  sm: 8, md: 12, lg: 16, xl: 20,
  r12: 12, r16: 16, r20: 20, r22: 22, r24: 24,
};

export const F = {
  // v6: Manrope = modernes, griffiges UI/Body (substanziell, semi-rund, passt zu
  // den dicken Icons). Plus Jakarta bleibt Fallback. Display/Zahlen unverändert.
  // (Sora getestet & verworfen — User bleibt bei Manrope für die ganze Body-UI.)
  family:  "'Hanken Grotesk', system-ui, -apple-system, sans-serif",
  // Wortmarke „red." + Plan-Labels bleiben auf Plus Jakarta (gelockte Brand-
  // Regel, NICHT auf Nunito mitziehen — feedback_wordmark_font_rule).
  brand:   "'Plus Jakarta Sans', 'Manrope', system-ui, -apple-system, sans-serif",
  // v3 Editorial: Bricolage Grotesque für Display-Headlines, Space Grotesk für Zahlen.
  // Fallback Jakarta, damit alte Komponenten ohne Schriftladen funktionieren.
  display: "'Hanken Grotesk', system-ui, -apple-system, sans-serif",
  mono:    "'Hanken Grotesk', ui-monospace, monospace",
  num:     "'Hanken Grotesk', system-ui, -apple-system, sans-serif",
};

// Tabular-Nums-Hilfsstyle für Zahlenanzeigen (Kurse, Mengen, Prozente).
// Handoff-Name: MONO_FEAT — Alias NUM_STYLE für Compat.
export const MONO_FEAT = {
  fontFamily: F.num,
  fontVariantNumeric: 'tabular-nums',
  fontFeatureSettings: '"tnum" 1, "lnum" 1',
};
export const NUM_STYLE = MONO_FEAT;

// EINE Bewegungs-Handschrift app-weit (Single Source of Truth). Diese Spring-
// Kurve (≈ easeOutExpo) wird auch von Motion.js und index.css referenziert —
// schnelle Annäherung + ruhiger Auslauf = „teurer" Eindruck. Vorher koexistierte
// hier ein flacheres easeOutQuad, das gegen die Motion-Spring lief.
export const EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

// Dauer-Tokens (Regel 2 „polished UI": keine Einmalwerte — ALLE Motion-Dauern aus
// diesem Satz). Werte in ms. Gespiegelt als :root-CSS-Variablen (--dur-*) in
// index.css → EINE Quelle für JS (framer/inline) UND CSS.
export const DUR = {
  press: 140,    // Tap-/Press-Feedback (kürzest)
  fast: 180,     // Hover-Mikro-Motion, Farbwechsel
  base: 220,     // Standard-Transition, kurzes Indikator-Gleiten
  slow: 320,     // Sheets, größere Layout-Moves
  entrance: 400, // Screen-/Listen-Eintritt
};

// ── Plan system ────────────────────────────────────────────────────
export const PLAN_COLORS = (T_) => ({
  free:    T_.mute,
  premium: T_.red,
  vip:     T_.silver,
});

export const PLAN_GRADIENTS = (T_) => ({
  free:    `linear-gradient(155deg, ${withAlpha(T_.mute, 0.20)} 0%, ${withAlpha(T_.mute, 0.04)} 50%, ${T_.surface} 100%)`,
  premium: `linear-gradient(155deg, rgba(228,84,74,0.30) 0%, rgba(228,84,74,0.05) 50%, ${T_.surface} 100%)`,
  vip:     `linear-gradient(155deg, rgba(212,213,222,0.30) 0%, rgba(212,213,222,0.05) 50%, ${T_.surface} 100%)`,
});

// ── Atmospheric recipes ────────────────────────────────────────────
export const heroBg = (T_, accent = T_.red) =>
  `linear-gradient(165deg, ${withAlpha(accent, 0.10)} 0%, rgba(255,255,255,0.01) 55%), ${T_.surface}`;

export const heroBorder = (accent) => `1px solid ${withAlpha(accent, 0.22)}`;

export const radialGlow = (accent) =>
  `radial-gradient(circle, ${withAlpha(accent, 0.30)} 0%, transparent 65%)`;

// Tiny helper — supports #RRGGBB or named already-rgba.
export function withAlpha(color, alpha) {
  if (!color) return `rgba(0,0,0,${alpha})`;
  if (color.startsWith('rgba')) return color;
  if (color.startsWith('rgb(')) {
    return color.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`);
  }
  if (color.startsWith('#')) {
    const hex = color.slice(1);
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r},${g},${b},${alpha})`;
  }
  return color;
}

// ── Accent / Theme Helpers (Handoff-Pattern) ────────────────────────
// makeAccent leitet helleres / dunkleres Rot vom signal-Hex ab und liefert ein
// Accent-Objekt mit { signal, hi, dark, a(alpha) }. Wird projektweit für
// Buttons, Active-Nav, Akzent-Striche genutzt.
export function makeAccent(signal = '#E4544A') {
  const h = signal.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const mix = (c, t, amt) => Math.round(c + (t - c) * amt);
  const toHex = (r2, g2, b2) => '#' + [r2, g2, b2]
    .map(x => x.toString(16).padStart(2, '0'))
    .join('');
  const hi   = toHex(mix(r, 255, 0.28), mix(g, 255, 0.18), mix(b, 255, 0.16));
  const dark = toHex(mix(r, 0, 0.18),   mix(g, 0, 0.18),   mix(b, 0, 0.18));
  return {
    signal,
    hi,
    dark,
    a: (x) => withAlpha(signal, x),
  };
}

// getTheme(mode) — Handoff-Pattern. Liefert das Themen-Objekt inkl. Accent.
// Wer nur die Tokens braucht, importiert weiter direkt T / T_LIGHT.
export function getTheme(mode = 'dark', accentHex = '#E4544A') {
  const base = mode === 'light' ? T_LIGHT : T;
  return { ...base, accent: makeAccent(accentHex) };
}

// ── Mobile-UI-Token-Ebene (breakpoint-aware) ───────────────────────
// iOS-Redesign der MOBILE-Ansicht (<768px): runder, großzügiger, weiche
// neutrale Tiefe — OHNE Desktop zu verändern. Desktop liefert hier bewusst die
// scharfen Editorial-Werte (radius 3), damit `borderRadius: ui.radius.card` auf
// Desktop=3 / Mobile=16 ergibt und der Web-Look unangetastet bleibt.
// Regel bleibt: KEINE rot-getönten Flächen/Glows (feedback_no_pills_borders_glow) —
// die Schatten sind neutral. Wird im ThemeContext gebaut (kennt isMobile+isDark).
const SPACE = { xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 24, xxxl: 32, gutter: 16 };

export function makeUI({ isMobile = false, isDark = true } = {}) {
  if (!isMobile) {
    // Desktop/Tablet: organisch gerundet (v5, wie Navbar/Mobile). R.sharp bleibt
    // nur für explizit flache Stellen.
    return {
      isMobile: false,
      radius: { card: 16, control: 12, input: R.input, sheet: 20, chip: 12, tile: 14, pill: R.pill },
      space:  SPACE,
      touch:  { min: 40, icon: 40, fab: 54 },
      shadow: {
        card: isDark ? '0 8px 24px rgba(0,0,0,0.40)' : '0 1px 2px rgba(60,48,28,0.04), 0 10px 30px rgba(60,48,28,0.05)',
        lift: isDark ? '0 12px 30px rgba(0,0,0,0.22)' : '0 6px 22px rgba(60,48,28,0.07)',
      },
    };
  }
  // Mobile: iOS-Standard rund + großzügiger Raum + weiche neutrale Tiefe.
  return {
    isMobile: true,
    radius: { card: 16, control: 12, input: 12, sheet: 20, chip: 10, tile: 14, pill: 999 },
    space:  SPACE,
    touch:  { min: 44, icon: 44, fab: 56 },
    shadow: {
      card: isDark ? '0 6px 20px rgba(0,0,0,0.28)' : '0 1px 2px rgba(60,48,28,0.04), 0 8px 24px rgba(60,48,28,0.06)',
      lift: isDark ? '0 14px 34px rgba(0,0,0,0.34)' : '0 8px 26px rgba(60,48,28,0.09)',
    },
  };
}

// Screen-Inline-Radius-Helfer (Hook-frei): auf Mobile (<768px) den runden Wert,
// sonst den scharfen Editorial-Default (3). Für die vielen Inline-Card-Radien in
// den Screens, wo Context-Plumbing in jede Sub-Komponente unpraktikabel wäre.
// Reaktiv: ThemeProvider rendert bei Resize neu (neuer ui-Context) → alle
// useTheme-Consumer rendern neu und lesen mr() frisch. Desktop bleibt 1:1.
let _vpMobile = typeof window !== 'undefined' && window.innerWidth < 768;
if (typeof window !== 'undefined') {
  window.addEventListener('resize', () => { _vpMobile = window.innerWidth < 768; });
}
export const mr = (mobileVal, desktopVal = R.soft) => (_vpMobile ? mobileVal : desktopVal);

// ── Type scale (v2) ────────────────────────────────────────────────
export const TYPE = {
  displayM: { fontFamily: F.display, fontSize: 62, fontWeight: 700, letterSpacing: '-0.055em', lineHeight: 0.95 },
  displayS: { fontFamily: F.display, fontSize: 54, fontWeight: 700, letterSpacing: '-0.06em',  lineHeight: 1 },
  h1:       { fontFamily: F.display, fontSize: 30, fontWeight: 700, letterSpacing: '-0.04em' },
  h2:       { fontFamily: F.display, fontSize: 16, fontWeight: 600, letterSpacing: '-0.02em' },
  bodyL:    { fontSize: 14,   fontWeight: 500, letterSpacing: '-0.01em' },
  bodyM:    { fontSize: 12.5, fontWeight: 500, letterSpacing: '-0.01em' },
  bodyS:    { fontSize: 11,   fontWeight: 500 },
  caps:     { fontSize: 10.5, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase' },
  mono:     { fontFamily: F.mono, fontWeight: 600, letterSpacing: '-0.02em', fontFeatureSettings: '"tnum" 1' },
};
